import React from 'react'

import { ThemeModeType, ToolItemType } from '@application/Types/ComponentTypes'

import { Arrow, Image, Link, Title, Wrapper } from './ToolItem.styled'

type ToolItemProps = {
    item: ToolItemType
    mode: ThemeModeType
}

export const ToolItem = ({ item, mode }: ToolItemProps): JSX.Element => {
    return (
        <Wrapper $mode={mode}>
            {item.icon && <Image image={item.icon} width={42} height={42} />}
            <Title>{item.title}</Title>
            <Link to={item.link}>
                {item.linkLabel}
                <Arrow colorCode="p500" />
            </Link>
        </Wrapper>
    )
}
